import { useEffect, useRef } from 'react';

import { Button } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { useTrackNavigationEvent } from '../../tracking';

export const PricingCTA = () => {
  const hasTrackedImpression = useRef(false);
  const trackNavigationEvent = useTrackNavigationEvent();

  useEffect(() => {
    if (!hasTrackedImpression.current) {
      trackNavigationEvent({
        viewType: 'impression',
        copy: 'pricing',
        additionalFields: {
          upsell_name: 'top_nav_bar_upgrade',
        },
        feature: 'general',
        element: 'button',
        eventName: 'vimeo.upsell_trigger_impression',
        version: 5,
      });
    }
  }, [trackNavigationEvent]);

  return (
    <Button
      variant="tertiary"
      as="a"
      href="/upgrade-plan"
      onClick={() => {
        trackNavigationEvent({
          actionType: 'click',
          feature: 'general',
          element: 'button',
          copy: 'pricing',
          eventName: 'vimeo.trigger_upsell',
          additionalFields: {
            upsell_name: 'top_nav_bar_upgrade',
          },
          version: 7,
        });
        trackNavigationEvent({ copy: 'pricing', element: 'button', feature: 'pricing' });
      }}
      size={{ base: 'sm', sm: 'md' }}
    >
      {translate('Pricing')}
    </Button>
  );
};
